import React from "react";
import styled from "styled-components";
import { Column, Text, Button, Row } from "../theme/index";
import ReactMarkdown from "react-markdown";

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 5px;
  border: 1px solid #1c334f;
  background: #fff;
  align-self: center;
  justify-self: center;
  grid-area: r;
  overflow: auto;
`;

// const Border = styled.div`
//   border: 0.5px solid #2b2b2b;
//   padding: 0.5em;
//   height: 100%;
//   display: flex;
//   align-items: center;
//   flex-direction: column;
// `;

const Div = styled.div`
  border: 1px solid #ffaf77;
  height: 0.5px;
  width: 40%;
  background-color: #ffaf77;
  margin: 0 auto;
  margin-bottom: 1.5em;
`;

const StyledColumn = styled(Column)`
  align-items: center;
  margin: 0 auto;
  width: 85%;
  text-align: center;
  padding-bottom: 1em;
  @media (max-width: 1100px) {
    width: 95%;
  }
`;

export default function Requirements({
  type,
  totalHours,
  mandatoryHours,
  generalHours,
  requirementsDescription,
  allOnline,
  ceRequirements,
  aboutThisCourse,
  handleSubmit
}) {
  return (
    <Wrapper>
      {/* <Border> */}
      <Text protitle textalign="center">
        {type === "profession"
          ? "CE Requirements"
          : type === "course"
          ? "About this Course"
          : "About this Package"}
      </Text>
      <Div />

      {type === "profession" && (
        <React.Fragment>
          {!ceRequirements && (
            <Column margin=".15em">
              <Text testimony2 textalign="center" color="#2b2b2b">
                {totalHours}
              </Text>
              <Column width="90%" margin="0 auto">
                <Text
                  textalign="left"
                  fontweight="600"
                  color="#2b2b2b"
                  margin="0"
                >
                  Mandatory hours:
                </Text>
                <ul>
                  {mandatoryHours &&
                    mandatoryHours.map((key, index) => {
                      return <li key={index}>{key}</li>;
                    })}
                </ul>
                <Text
                  textalign="left"
                  fontweight="600"
                  color="#2b2b2b"
                  margin="0"
                >
                  General hours: {generalHours}
                </Text>
                <Text
                  textalign="left"
                  fontweight="600"
                  color="#2b2b2b"
                  margin="0"
                >
                  {allOnline}
                </Text>
              </Column>
            </Column>
          )}
          {ceRequirements && (
            <Column width="90%" margin="0 auto">
              <ReactMarkdown escapeHtml={false} source={ceRequirements} />
            </Column>
          )}
        </React.Fragment>
      )}
      {type === "course" && (
        <React.Fragment>
          {!aboutThisCourse && (
            <StyledColumn>
              <Text testimony2 color="#2b2b2b">
                {requirementsDescription}
              </Text>
              <Row margin="2em 0">
                <Button buy onClick={handleSubmit}>
                  Get Started
                </Button>
              </Row>
            </StyledColumn>
          )}
          {aboutThisCourse && (
            <Column width="90%" margin="0 auto" alignitems="center">
              <ReactMarkdown escapeHtml={false} source={aboutThisCourse} />
              <Row margin="2em 0">
                <Button buy onClick={handleSubmit}>
                  Get Started
                </Button>
              </Row>
            </Column>
          )}
        </React.Fragment>
      )}
      {type === "bundle" && (
        <React.Fragment>
          {!aboutThisCourse && (
            <StyledColumn>
              <Text testimony2 color="#2b2b2b">
                {requirementsDescription}
              </Text>
              <Row margin="2em 0">
                <Button buy onClick={handleSubmit}>
                  Get Started
                </Button>
              </Row>
            </StyledColumn>
          )}
          {aboutThisCourse && (
            <Column width="90%" margin="0 auto" alignitems="center">
              <ReactMarkdown escapeHtml={false} source={aboutThisCourse} />
              <Row margin="2em 0">
                <Button buy onClick={handleSubmit}>
                  Get Started
                </Button>
              </Row>
            </Column>
          )}
        </React.Fragment>
      )}
    </Wrapper>
  );
}



// WEBPACK FOOTER //
// ./src/components/shared/Requirements.jsx